import script from "./SignInPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInPage.vue?vue&type=style&index=0&id=e1625d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1625d7a"]])

export default __exports__